import { render, staticRenderFns } from "./Masquerade.vue?vue&type=template&id=677bb8e2&scoped=true&"
import script from "./Masquerade.vue?vue&type=script&lang=js&"
export * from "./Masquerade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677bb8e2",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
